import { render, staticRenderFns } from "./boardListPage.vue?vue&type=template&id=33d862ec&scoped=true&"
import script from "./boardListPage.vue?vue&type=script&lang=js&"
export * from "./boardListPage.vue?vue&type=script&lang=js&"
import style0 from "./boardListPage.vue?vue&type=style&index=0&id=33d862ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d862ec",
  null
  
)

export default component.exports